'use client';

/**
 * Room Designer Page
 *
 * Portal-only AI room designer powered by Royale Spaces.
 * Users select images from their wishlisted properties to reimagine.
 */

import { SpacesView } from '@/components/client-portal';

export default function SpacesPage() {
  return <SpacesView />;
}
